import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ToDoDetails from "./ToDoDetails";
import NotificationManagement from "./NotificationManagement";
import CreateAndUpdateTemplate from "../../../component/ReusableComponent/CreateAndUpdateTemplate";

const Create = (props) => {
  const [step, setStep] = useState(1);
  const { stepNumber } = useSelector((state) => state.tempWindowsData);

  useEffect(() => {
    if (stepNumber) {
      setStep(3);
    }
  }, []);

  return (
    <div className="sm:mx-6 lg:mx-8">
      <div className={`sm:block sm:pt-1`}>
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="users"
            >
              To Do Details
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2  ${
                step === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="customers"
            >
              To Do Form
            </a>
          </li>
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 3 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="collaborators"
            >
              Notification Management
            </a>
          </li>
          
        </ul>
      </div>

      {step === 1 && <ToDoDetails setStep={setStep} />}

      {step === 2 && <CreateAndUpdateTemplate setStep={setStep} step={step} />}

      {step === 3 && <NotificationManagement setStep={setStep} step={step} />}
    </div>
  );
};

Create.auth = { path: "/activity/create", role: "super-admin admin" };
export default Create;
